// addAppBuildOutcome.js — what the builder's Preview pane says when a build
// left nothing on it (wt/presets qa/briefs/WS-build-ui-r1.md finding 3).
//
// aiko and tomas met a pane that read "Your idea is taking shape" for a whole
// session: every build step failed, or the board showed somewhere else, and
// the pane never said so. The pane shows the built app (pages/add-app.js
// AppRender), or it says plainly that the build failed.
//
// READ, NEVER STORED: the answer comes from the builder's own thread
// (`_ax_chatMessages` — the live turn's timeline rows, or a restored thread's)
// and the pane's own flag (`_addAppRendered`). A stored flag would need its own
// clearing on every send, switch and reload; the rows already say it.
//
// FRANK: self-contained (FA204) — the step list is restated in the function.

// The builder's outcome → 'failed' | null.
//   'failed'  the newest assistant answer that ran a BUILD step is finished,
//             at least one build step failed, none succeeded, and the pane
//             holds nothing — the build ended with nothing to show;
//   null      still working (the newest answer streams), something is on the
//             pane (or loading into it), a failed step was followed by one
//             that worked, or no build step ran at all.
// A later answer with no build step (a question after the failure) keeps the
// failure on the pane: the scan goes back to the newest answer that built.
export function addAppBuildOutcome(root) {
  const el = this
  const r = root || (el && el.state && el.state.root) || null
  if (!r) return null
  if (r._addAppRendered || r._addAppSwitching) return null
  const msgs = Array.isArray(r._ax_chatMessages) ? r._ax_chatMessages : []
  // The steps that put an app on the pane — server tool names (the timeline
  // rows carry them; a module fn's transport prefix stripped) — and the two
  // that build a project without drawing it here (a project made and left
  // empty is no app to show).
  const RENDER = [
    'create_app',
    'update_app',
    'create_extension',
    'update_extension',
    'render_extension_page',
    'render_answer_ui'
  ]
  const BUILD = RENDER.concat(['create_project', 'commit_project_changes'])
  const nameOf = (t) => String((t && t.tool) || '').replace(/^module_fn_/, '')
  for (let i = msgs.length - 1; i >= 0; i--) {
    const m = msgs[i]
    if (!m || m.role !== 'assistant') continue
    if (m.streaming) return null
    const rows = (Array.isArray(m.tools) ? m.tools : []).filter((t) => BUILD.includes(nameOf(t)))
    if (!rows.length) continue
    const failed = rows.some((t) => t.status === 'error')
    const worked = rows.some((t) => t.status === 'done' && RENDER.includes(nameOf(t)))
    return failed && !worked ? 'failed' : null
  }
  return null
}
